import { capitalize } from "lodash";

import { FormType } from "@/integrations";

import FormFactory from "./FormFactory";

export default function OAuthForm({
  field,
}: {
  field: Extract<FormType, { type: "oauth" }>;
}) {
  const { label } = field;

  return (
    <div>
      <p className="text-sm">
        Connect to {capitalize(label)} with the button below. This will take you
        to {capitalize(label)}'s authorization flow, where you can grant access
        to your data.
      </p>
      {field.fields && field.fields.length > 0 && (
        <div className="mt-6">
          {field.fields?.map((f, i) => (
            <FormFactory key={i} form={f} />
          ))}
        </div>
      )}
    </div>
  );
}
